// ** Navigation sections imports
import radioData from "./RadioData";
import main from "./Main";
import Support from "./Support";
import SiteData from "./SiteData";
import Administration from "./Administration";

// ** Merge & Export
export default [
  ...main,
  ...radioData,
  ...SiteData,
  ...Support,
  ...Administration,
];
